// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination-mobile[data-v-5f72e89e] {\n  flex-wrap: wrap;\n}\n.pagination-mobile .pagination-list[data-v-5f72e89e] {\n  order: -1;\n  flex-basis: 100%;\n  justify-content: center;\n  margin-bottom: 0.75rem;\n}\n.pagination-mobile .pagination-previous[data-v-5f72e89e],\n.pagination-mobile .pagination-next[data-v-5f72e89e] {\n  flex-grow: 1;\n  flex-basis: 0;\n}", ""]);
// Exports
module.exports = exports;
